import type { CanDeactivateFn, GuardResult, MaybeAsync } from '@angular/router';
import { openInfoToast, openSuccessToast } from '@pct-ng/feature-message-material';
import { I18nProviderInjectionToken } from '../i18n/scope';
import { isWithForm, isWithFormState, type WithFormState } from '../reactive-forms/with-form';
import type { FormState } from '../reactive-forms/form-state';
import { translateTranslateAbleText } from '@pct-ng/i18n';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

const i18nPrefix = `${I18nProviderInjectionToken.scope}.MESSAGE.FORM_STATE.`;

function showToaster(state: FormState, name: string): void {
  if (state === 'NOT_MODIFIED') {
    openInfoToast({
      message: { text: `${i18nPrefix}NOT_MODIFIED`, translate: true, translateParams: { name } },
    });
  }
  // TODO: core change
  else if (state === 'CREATED' || state === 'MODIFIED') {
    openSuccessToast({
      message: { text: `${i18nPrefix}SAVED`, translate: true, translateParams: { name } },
    });
  }
}

export const showToasterDeactivateGuard =
  (name: string): CanDeactivateFn<WithFormState> =>
  (component: WithFormState): MaybeAsync<GuardResult> => {
    if (!isWithForm(component) && !isWithFormState(component)) {
      console.error('Component has not a form state');
      return true;
    }

    const translatedName = translateTranslateAbleText(name, inject(TranslocoService));

    if (isWithForm(component)) {
      showToaster(component.form.formState, translatedName);
    } else if (isWithFormState(component)) {
      showToaster(component.formState, translatedName);
    } else {
      console.error('Component has not a form state');
      return true;
    }

    return true;
  };
